import classNames from 'classnames';
import { Path } from 'react-hook-form';
import { ErrorMessage } from './Input';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import { useRouter } from 'next/router';
type InputTermsProps<FormTypes> = {
  name: Path<FormTypes>;
  errors: any;
  register: any;
  labelClassNames?: string;
  onClick?: () => void;
  hasSingleTerms?: boolean;
};

export function InputTerms<FormTypes>({
  name,
  errors,
  register,
  labelClassNames,
  onClick,
  hasSingleTerms,
}: InputTermsProps<FormTypes>) {
  const { t } = useTranslation();
  const { locale } = useRouter();
  // TODO: use Input type checkbox component
  return (
    <div>
      <input
        type='checkbox'
        id={name}
        {...register(name, {
          required: true,
        })}
        className='h-4 w-4'
      />
      <label htmlFor={name}>
        <span
          className={classNames('ml-2 text-sm text-muted-500', labelClassNames)}
        >
          {locale != 'tr-TR' ? (
            <>
              {t('mygindumac:FORM_PLACEHOLDER_TERMSACCEPT1')}{' '}
              <PrivacyLink onClick={onClick} capitalize={hasSingleTerms} />
              {hasSingleTerms ? (
                <>
                  {' ' + t('mygindumac:TEXT_AND') + ' '}
                  <TermsAndConditions onClick={onClick} />
                </>
              ) : (
                <>
                  {', '}
                  <TermsAndConditionsOfPurchase onClick={onClick} />
                  {'  ' + t('mygindumac:TEXT_AND') + '  '}
                  <TermsAndConditionsOfSales onClick={onClick} />
                </>
              )}
            </>
          ) : (
            <>
              <PrivacyLink onClick={onClick} /> ,{' '}
              <TermsAndConditionsOfPurchase onClick={onClick} />
              {' ' + t('mygindumac:TEXT_AND') + ' '}
              <TermsAndConditionsOfSales onClick={onClick} />
              {t('mygindumac:FORM_PLACEHOLDER_TERMSACCEPT1')}
            </>
          )}
        </span>
      </label>
      <ErrorMessage errors={errors} name={name} />
    </div>
  );
}
function PrivacyLink({
  onClick,
  capitalize,
}: {
  onClick?: () => void;
  capitalize?: boolean;
}) {
  const { t } = useTranslation();

  if (onClick) {
    return (
      <span
        onClick={onClick}
        className={classNames(
          'cursor-pointer underline',
          capitalize ? 'capitalize' : 'uppercase'
        )}
      >
        {t('mygindumac:FORM_PLACEHOLDER_PRIVACYACCEPT')}
      </span>
    );
  }

  return (
    <Link href='/privacy'>
      <a target='_blank' className='uppercase underline'>
        {t('mygindumac:FORM_PLACEHOLDER_PRIVACYACCEPT')}
      </a>
    </Link>
  );
}

function TermsAndConditionsOfSales({ onClick }: { onClick?: () => void }) {
  const { t } = useTranslation();

  if (onClick) {
    return (
      <span onClick={onClick} className='cursor-pointer uppercase underline'>
        {t('mygindumac:FOOTER_TERMS_AND_CONDITIONS_OF_SALE')}
      </span>
    );
  }

  return (
    <Link href='/general-terms-and-conditions-of-purchase'>
      <a target='_blank' className='uppercase underline'>
        {t('mygindumac:FOOTER_TERMS_AND_CONDITIONS_OF_SALE')}
      </a>
    </Link>
  );
}

function TermsAndConditionsOfPurchase({ onClick }: { onClick?: () => void }) {
  const { t } = useTranslation();

  if (onClick) {
    return (
      <span onClick={onClick} className='cursor-pointer uppercase underline'>
        {t('mygindumac:FOOTER_TERMS_AND_CONDITIONS_OF_PURCHASE')}
      </span>
    );
  }

  return (
    <Link href='/general-terms-and-conditions-of-sale'>
      <a target='_blank' className='uppercase underline'>
        {t('mygindumac:FOOTER_TERMS_AND_CONDITIONS_OF_PURCHASE')}
      </a>
    </Link>
  );
}

function TermsAndConditions({ onClick }: { onClick?: () => void }) {
  const { t } = useTranslation();

  if (onClick) {
    return (
      <span onClick={onClick} className='cursor-pointer uppercase underline'>
        {t('products:CKECKOUT_TERMS_AND_CONDITIONS_CHECK')}
      </span>
    );
  }

  return (
    <Link href='/general-terms-and-conditions-of-sale'>
      <a target='_blank' className='uppercase underline'>
        {t('products:CKECKOUT_TERMS_AND_CONDITIONS_CHECK')}
      </a>
    </Link>
  );
}
